/* eslint-disable */
<template>
  <div>

    <vs-card>
      <vs-tabs>

        <vs-tab label="Dados de Mercado CCEE">
          <vs-row class="mt-4">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="9">
              <label class="file-select">
                <!-- We can't use a normal button element here, as it would become the target of the label. -->
                <div class="select-button">
                  <!-- Display the filename if a file has been selected. -->
                  <span v-if="file">Arquivo selecionado: {{file.name}}</span>
                  <span v-else class="vs-component vs-button vs-button-primary vs-button-filled">Selecione um arquivo</span>
                </div>
                <!-- Now, the file input that we hide. -->
                <input type="file" ref="file" @change="handleFileUpload"/>
              </label>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="right" vs-w="3">
              <vs-button v-if="file" @click="upload">Upload</vs-button>
            </vs-col>
          </vs-row>

          <vs-row class="mt-4">
            <vs-col>
              <vs-table stripe :data="cceeLog" noDataText="Nenhum registro encontrado.">

                <template slot="thead">
                  <th>Data</th>
                  <th>Nome do Arquivo</th>
                  <th>Hash</th>
                  <th>Usuário</th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(row, indextr) in data">
                    <td>
                      {{row.executedAt | formatDate}}
                    </td>
                    <td>
                      {{row.fileName}}
                    </td>
                    <td>
                      {{row.fileMd5}}
                    </td>
                    <td>
                      {{row.user.email}}
                    </td>
                  </vs-tr>
                </template>

              </vs-table>
            </vs-col>
          </vs-row>


        </vs-tab>

        <vs-tab label="Cias Abertas Robot">
          <vs-button @click="ciasAbertasRobot">Executar</vs-button>
          <vs-row class="mt-4">
            <vs-col>
              <vs-table stripe :data="ciasAbertasLog" noDataText="Nenhum registro encontrado.">

                <template slot="thead">
                  <th>Data</th>
                  <th>Nome do Arquivo</th>
                  <th>Hash</th>
                  <th>Usuário</th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(row, indextr) in data">
                    <td>
                      {{row.executedAt | formatDate}}
                    </td>
                    <td>
                      {{row.fileName}}
                    </td>
                    <td>
                      {{row.fileMd5}}
                    </td>
                    <td>
                      {{row.user.email}}
                    </td>
                  </vs-tr>
                </template>

              </vs-table>
            </vs-col>
          </vs-row>
        </vs-tab>

        <vs-tab label="ITR Robot">
          <vs-button @click="itrRobot">Executar</vs-button>
          <vs-row class="mt-4">
            <vs-col>
              <vs-table stripe :data="itrLog" noDataText="Nenhum registro encontrado.">

                <template slot="thead">
                  <th>Data</th>
                  <th>Nome do Arquivo</th>
                  <th>Hash</th>
                  <th>Usuário</th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(row, indextr) in data">
                    <td>
                      {{row.executedAt | formatDate}}
                    </td>
                    <td>
                      {{row.fileName}}
                    </td>
                    <td>
                      {{row.fileMd5}}
                    </td>
                    <td>
                      {{row.user.email}}
                    </td>
                  </vs-tr>
                </template>

              </vs-table>
            </vs-col>
          </vs-row>
        </vs-tab>

        <vs-tab label="Score Report">
          <vs-button @click="scoreReport">Download</vs-button>
        </vs-tab>

      </vs-tabs>
    </vs-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Robôs',
  data () {
    return {
      file: '',
      page: 1,
      totalPages: 0,
      cceeLog: [],
      ciasAbertasLog: [],
      itrLog: [],
      guaranteeLog: [],
      traderLog: []
    }
  },
  beforeMount () {
    this.getItrLog()
    this.getTraderLog()
    this.getCceeLog()
    this.getCiasAbertasLog()
  },
  methods: {
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },

    upload () {
      const formData = new FormData()
      formData.append('file', this.file)

      axios.post(`${process.env.VUE_APP_API}/api/v1/robot/info-mercado`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
    },

    ciasAbertasRobot () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/robot/cias-abertas`)
        .finally(() => {
          this.getCceeLog()
        })
    },

    itrRobot () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/robot/itr`)
        .finally(() => {
          this.getItrLog()
        })
    },

    getCceeLog () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/robot`, {
        params: {
          type: 'INFO_MERCADO'
        }
      })
        .then((response) => {
          this.cceeLog = response.data.content
        })
    },

    getCiasAbertasLog () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/robot`, {
        params: {
          type: 'CIA_ABERTA'
        }
      })
        .then((response) => {
          this.ciasAbertasLog = response.data.content
        })
    },

    getItrLog() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/robot`, {
        params: {
          type: 'ITR'
        }
      })
        .then((response) => {
          this.itrLog = response.data.content
        })
    },

    scoreReport() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/score/report`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    }

  }
}
</script>

<style scoped>
/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>
